import React from 'react';
import { Spacer, Text } from '@ontruck/orc';
import { OrderLink, TasksLink } from './idLink';

const shipperOrderBrokenRenderer = ({
  changes: { shipper_order_broken_id, journey_before_breaking_id, journey_after_breaking_id },
  ...props
}) => {
  return (
    <Spacer {...props}>
      {!!shipper_order_broken_id && !!journey_before_breaking_id && (
        <Text color="grey800" display="block">
          <OrderLink id={shipper_order_broken_id} />
          removed from <TasksLink id={journey_before_breaking_id} />
        </Text>
      )}
      {!!shipper_order_broken_id && !!journey_after_breaking_id && (
        <Text color="grey800" display="block">
          <OrderLink id={shipper_order_broken_id} />
          added to <TasksLink id={journey_after_breaking_id} />
        </Text>
      )}
      {!!shipper_order_broken_id && !journey_after_breaking_id && (
        <Text color="grey800" display="block">
          <OrderLink id={shipper_order_broken_id} />
          doesn't belong to any job
        </Text>
      )}
    </Spacer>
  );
};

export default shipperOrderBrokenRenderer;
